import { createFileRoute } from "@tanstack/react-router";
import SaintTmsInsuranceCoverageEs from "@/pages/es/SaintTmsInsuranceCoverageEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/saint-tms-insurance-coverage`;

export const Route = createFileRoute("/es/saint-tms-insurance-coverage")({
  head: () => ({
    meta: [
      { title: "Descubra qué cubre su plan — gratis | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Descubra qué cubre su plan para SAINT TMS — gratis. Verificamos sus beneficios sin costo y le decimos exactamente dónde está. Opciones de pago particular.",
      },
      { property: "og:title", content: "Descubra qué cubre su plan — gratis" },
      {
        property: "og:description",
        content:
          "Verificamos sus beneficios de SAINT TMS sin costo y le decimos exactamente dónde está.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Descubra qué cubre su plan — gratis" },
      {
        name: "twitter:description",
        content:
          "Verificamos sus beneficios de SAINT TMS sin costo y le decimos exactamente dónde está.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/saint-tms-insurance-coverage"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintTmsInsuranceCoverageEs />;
}
